/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { connect } from 'react-redux';
import { toast } from 'react-toastify';

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col
} from "reactstrap";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import SimpleFooter from "components/Footers/SimpleFooter.js";
import { loginUser, receiveToken, doInit } from '../actions/auth';
import axios from 'axios';

import { Tooltip } from 'reactstrap';

class Login extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      username: '',
      password: '',
      tooltipOpen:false,
      tooltipPasswordOpen: false
    };

  }
  componentDidMount() {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    this.refs.main.scrollTop = 0;
  }
  doLogin=(e)=>{
    e.preventDefault();
    this.props.loginUser({ email: this.state.email, password: this.state.password });
  }
  changeEmail=(event)=> {
    this.setState({ email: event.target.value });
  }

  changeUsername=(event)=> {
      this.setState({ username: event.target.value });
  }

  changePassword=(event)=> {
      this.setState({ password: event.target.value });
  }

  
  toggleToolTip = () => this.setState({tooltipOpen:!this.state.tooltipOpen});
  toggleToolTipPassword = () => this.setState({tooltipPasswordOpen:!this.state.tooltipPasswordOpen});
  render() {
    return (
      <>
        <DemoNavbar />
        <main ref="main" className="login-page">
          <img className="login-bg" width="100%" src={require("assets/img/bg-1.jpg").default}/>
          <section className="section section-shaped section-lg">
            <div className="">
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
              <span />
            </div>
            <Container className="pt-lg-7">
              <Row className="justify-content-center">
                <Col lg="5">
                  <Card className="bg-white shadow border-0 login-card">
                    
                    <CardBody className="px-lg-5 py-lg-5">
                      <div className="text-center text-muted mb-1">
                        <img width="80px" src={require("assets/img/brand/logo_small.png").default}/><br/>
                        <span style={{color:'black', fontSize:22}}><b>Log in to Your Account</b></span>
                      </div>
                      <Form role="form" onSubmit={this.doLogin}>
                        <FormGroup className="mb-3">
                          <InputGroup className="input-group-alternative" id="tooltip-email">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-email-83" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input placeholder="User Name/Email" type="email"  value={this.state.email} onChange={this.changeEmail} />
                          </InputGroup>
                        </FormGroup>
                        <FormGroup>
                          <InputGroup className="input-group-alternative" id="tooltip-password">
                            <InputGroupAddon addonType="prepend">
                              <InputGroupText>
                                <i className="ni ni-lock-circle-open" />
                              </InputGroupText>
                            </InputGroupAddon>
                            <Input
                              placeholder="Password"
                              type="password"
                              autoComplete="off"
                              value={this.state.password} onChange={this.changePassword}
                            />
                          </InputGroup>
                        </FormGroup>
                        <div className="text-center">
                          <Button
                            className="mb-2 w-100 rounded-0 login-btn"
                            color="primary"
                            type="submit"
                          >
                            LOG IN
                          </Button>
                          {
                            !this.props.auth.isFetching&&this.props.auth.errorMessage!=null&&
                            <p style={{color:'red', fontSize:'14px'}}>{this.props.auth.errorMessage}</p>
                          }
                        </div>
                      </Form>
                      
                      <Row className="mt-1">
                        <Col xs="6">
                          <a
                            className=""
                            href="javascript:void(0)"
                            onClick={()=>this.props.history.push(`/forgot`)}
                          >
                            <small>Forgot password?</small>
                          </a>
                        </Col>
                        <Col className="text-right" xs="6">
                          <a
                            className=""
                            href="javascript:void(0)"
                            onClick={()=>this.props.history.push(`/register-page`)}
                          >
                            <small>Create new account</small>
                          </a>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
                <Col lg="7" className="d-flex align-items-center justify-content-center">
                  <div>
                    <h1><b>Congratulations</b></h1>
                    <h3><b>Welcome to your</b><br/><b>Online Ordering Portal</b></h3>
                    <p>
                      Your business has qualified to use our custom online ordering portal.<br/>
                      Should you have any questions feel free to contact the team
                    </p>
                    <div className="d-flex align-items-center">
                      <a href="tel:0397865005" className="mr-2"><b>03 9786 5005</b></a>
                      <a href="mailto:team@bigbranding.com.au"><b> - team@bigbranding.com.au</b></a>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            <Tooltip placement="top" isOpen={this.state.tooltipOpen} className="text-left" target="tooltip-email" toggle={this.toggleToolTip}>
              Use the supplied email address to log in. The email address provided by the organization when they first requested a quote may no longer be current, but it can still be used to log in. Once you are logged in, you can change the email address if needed
            </Tooltip>
            <Tooltip placement="top" isOpen={this.state.tooltipPasswordOpen} className="text-left" target="tooltip-password" toggle={this.toggleToolTipPassword}>
              You have been provided with a password for your first login. After logging in, you can reset the password to something more personal if you wish.
            </Tooltip>
          </section>
        </main>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    loginUser: (email, password)=>dispatch(loginUser(email, password)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Login);
